<app-detail [name]="name"
            [id]="id"
            [apiController]="apiController"
            [views]="views"
            viewType="compressed"
            [toolbarItems]="toolbarItems"
            [keyFieldName]="keyFieldName">

</app-detail>

@if(!isEmpty){
<kendo-scrollview [data]="items"
                  [width]="width"
                  [height]="height"
                  [animate]="false"
                  [pagerOverlay]="'dark'"
                  [arrows]="true"
                  [pageable]="true">
  <ng-template let-item="item">
    <img class="displayImage"
         src="{{ item.image }}"
         alt="{{ item.name }}"
         draggable="false" />
  </ng-template>
</kendo-scrollview>
}
